import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.section`
padding-top: 12%;
padding-bottom: 10%;
h2{
    margin-left:21px;
    padding-bottom: 3%;
    color: #EC632F;

}
.first-p{
    color: #C8C8C8;
    margin-left:21px;
 margin-right: 55px;
 line-height: 1.3;
}

.cards-combo{
    padding-top: 9%;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.card{
    width: 90%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 6%;
    border: 1px solid #000;
    background: #FDFDFD;
    img{
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
h3{
    padding-top: 5%;
    text-align: center;
}
p{
    color: #C8C8C8;
    margin-left: 15px;
    line-height: 1.3;
    margin-right: 36px;
    padding-top: 4%;
    text-align: left;
}.text-combo{
    margin-left: 21px;
    display: flex;
    align-items: center;
padding-top: 10%;
gap: 10px;
}
}
.card-1{
    width: 90%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 6%;
    background: #FDFDFD;
    display: none;
    img{
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
h3{
    padding-top: 5%;
    text-align: center;
}
p{
    margin-left: 15px;
    line-height: 1.3;
    margin-right: 36px;
    padding-top: 4%;
    text-align: left;
}.text-combo{
    margin-left: 21px;
    display: flex;
    align-items: center;
padding-top: 10%;
gap: 10px;
}
}
.card-2{
    width: 90%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 6%;
    background: #FDFDFD;
    display: none;
    img{
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
h3{
    padding-top: 5%;
    text-align: center;
}
p{
    margin-left: 15px;
    line-height: 1.3;
    margin-right: 36px;
    padding-top: 4%;
    text-align: left;
}.text-combo{
    margin-left: 21px;
    display: flex;
    align-items: center;
padding-top: 10%;
gap: 10px;
}
}
.card-3{
    width: 90%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 6%;
    background: #FDFDFD;
    display: none;
    img{
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
h3{
    padding-top: 5%;
    text-align: center;
}
p{
    margin-left: 15px;
    line-height: 1.3;
    margin-right: 36px;
    padding-top: 4%;
    text-align: left;
}.text-combo{
    margin-left: 21px;
    display: flex;
    align-items: center;
padding-top: 10%;
gap: 10px;
}
}



@media (min-width: 768px){
    padding-top: 4%;
padding-bottom: 4%;
h2{
    text-align: center;
    margin-left:0px;
    padding-bottom: 3%;
}
.first-p{
    padding: 0 222px;
    text-align: center;
    color: #C8C8C8;
    margin-left:0px;
 margin-right: 0px;
 line-height: 1.3;
}

.cards-combo{
    padding-top: 3%;
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin: 0 25px;
}
 
.card-1{
    width: 90%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 6%;
    display: block;
    img{
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
h3{
    padding-top: 5%;
    text-align: center;
}
p{
    margin-left: 15px;
    line-height: 1.3;
    margin-right: 36px;
    padding-top: 4%;
    text-align: left;
}.text-combo{
    margin-left: 21px;
    display: flex;
    align-items: center;
padding-top: 10%;
gap: 10px;
}
}
}
@media (min-width: 992px){
    padding-top: 4%;
padding-bottom: 4%;
h2{
    text-align: center;
    margin-left:0px;
    padding-bottom: 3%;
}
.first-p{
    padding: 0 222px;
    text-align: center;
    color: #C8C8C8;
    margin-left:0px;
 margin-right: 0px;
 line-height: 1.3;
}

.cards-combo{
    padding-top: 3%;
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin: 0 38px;
}
 
.card{
    width: 35%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 6%;
    border: 1px solid #000;
    img{
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
h3{
    padding-top: 5%;
    text-align: center;
}
p{
    color: #C8C8C8;
    margin-left: 15px;
    line-height: 1.3;
    margin-right: 36px;
    padding-top: 4%;
    text-align: left;
}.text-combo{
    margin-left: 21px;
    display: flex;
    align-items: center;
padding-top: 10%;
gap: 10px;
}
}
.card-1{
    width: 35%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 6%;
    display: block;
    img{
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
h3{
    padding-top: 5%;
    text-align: center;
}
p{
    margin-left: 15px;
    line-height: 1.3;
    margin-right: 36px;
    padding-top: 4%;
    text-align: left;
}.text-combo{
    margin-left: 21px;
    display: flex;
    align-items: center;
padding-top: 10%;
gap: 10px;
}
}
.card-2{
    width: 35%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 6%;
    display: block;
    img{
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
h3{
    padding-top: 5%;
    text-align: center;
}
p{
    margin-left: 15px;
    line-height: 1.3;
    margin-right: 36px;
    padding-top: 4%;
    text-align: left;
}.text-combo{
    margin-left: 21px;
    display: flex;
    align-items: center;
padding-top: 10%;
gap: 10px;
}
}
}
@media (min-width: 1200px){
    padding-top: 4%;
padding-bottom: 4%;
h2{
    text-align: center;
    margin-left:0px;
    font-size: 33px;
  font-weight: 600;

    padding-bottom: 3%;
}
.first-p{
    padding: 0 222px;
    text-align: center;
    color: #C8C8C8;
    margin-left:0px;
 margin-right: 0px;
 line-height: 1.3;
}

.cards-combo{
    padding-top: 3%;
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin: 0 90px;
}
 
.card{
    width: 35%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 2%;
    border: 1px solid #000;
    img{
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
h3{
    padding-top: 5%;
    text-align: center;
}
p{
    color: #C8C8C8;
    margin-left: 15px;
    line-height: 1.3;
    margin-right: 36px;
    padding-top: 4%;
    text-align: left;
    font-size: 14px;
    font-weight: 300;
}.text-combo{
    margin-left: 21px;
    display: flex;
    align-items: center;
padding-top: 10%;
gap: 10px;
}
span{
    font-size: 14px;
    font-weight: 300;
}
h4{
  font-size: 14px;
}
}
.card-1{
    width: 35%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 2%;
    display: block;
    img{
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
h3{
    padding-top: 5%;
    text-align: center;
}
p{
    margin-left: 15px;
    line-height: 1.3;
    margin-right: 36px;
    padding-top: 4%;
    text-align: left;
    color: #C8C8C8;
    font-weight: 300;
font-size: 14px;
}
span{
    font-size: 14px;
    font-weight: 300;
}
h4{
  font-size: 14px;
}
.text-combo{
    margin-left: 21px;
    display: flex;
    align-items: center;
padding-top: 10%;
gap: 10px;
}
}
.card-2{
    width: 35%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 2%;
    display: block;
    img{
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
h3{
    padding-top: 5%;
    text-align: center;
}
p{
    margin-left: 15px;
    line-height: 1.3;
    margin-right: 36px;
    padding-top: 4%;
    text-align: left;
    color: #C8C8C8;
    font-size: 14px;
    font-weight: 300;

}.text-combo{
    margin-left: 21px;
    display: flex;
    align-items: center;
padding-top: 10%;
gap: 10px;
}
span{
    font-size: 14px;
    font-weight: 300;
}
h4{
  font-size: 14px;
}
}
.card-3{
    width: 35%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 2%;
    display: block;
    img{
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}
h3{
    padding-top: 5%;
    text-align: center;
}
p{
    margin-left: 15px;
    line-height: 1.3;
    margin-right: 36px;
    padding-top: 4%;
    text-align: left;
    font-size: 14px;
    color: #C8C8C8;
    font-weight: 300;

}.text-combo{
    margin-left: 21px;
    display: flex;
    align-items: center;
padding-top: 10%;
gap: 10px;
}
span{
    font-size: 14px;
    font-weight: 300;
}
h4{
  font-size: 14px;
}
}
}

`
function Testimonials() {
  return (
    <Wrapper>
      <div className='section'>
<h2>Testimonials</h2>
<p className='first-p'>At Favour, we're passionate about creating a nurturing and joyful learning environment for every child.</p>

<div className='cards-combo'>

<div className='card'>
<img src="./photos/manykids.png" alt=""/>
    <p>"[My child] has blossomed at Favour! Ms. Sunshine's creativity and enthusiasm have instilled a love for learning, and he comes home every day singing new songs and sharing exciting stories about his adventures."</p>
    <div className='text-combo'>
        <h4>George Ndlovu</h4>
        <span>Parent of a 3-year-old</span>
    </div>
</div>
<div className='card-1'>
<img src="./photos/manykids.png" alt=""/>
    <p>"[My child] has blossomed at Favour! Ms. Sunshine's creativity and enthusiasm have instilled a love for learning, and he comes home every day singing new songs and sharing exciting stories about his adventures."</p>
    <div className='text-combo'>
        <h4>George Ndlovu</h4>
        <span>Parent of a 3-year-old</span>
    </div>
</div>
<div className='card-2'>
<img src="./photos/manykids.png" alt=""/>
    <p>"[My child] has blossomed at Favour! Ms. Sunshine's creativity and enthusiasm have instilled a love for learning, and he comes home every day singing new songs and sharing exciting stories about his adventures."</p>
    <div className='text-combo'>
        <h4>George Ndlovu</h4>
        <span>Parent of a 3-year-old</span>
    </div>
</div>
<div className='card-3'>
<img src="./photos/manykids.png" alt=""/>
    <p>"[My child] has blossomed at Favour! Ms. Sunshine's creativity and enthusiasm have instilled a love for learning, and he comes home every day singing new songs and sharing exciting stories about his adventures."</p>
    <div className='text-combo'>
        <h4>George Ndlovu</h4>
        <span>Parent of a 3-year-old</span>
    </div>
</div>

</div>









      </div>
    </Wrapper>
  )
}

export default Testimonials
